import { useQuery } from '@tanstack/react-query';
import { fetchAgeGroups } from '../../../api/administration/demographics/personas';

export const useAgeGroups = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['age-groups', filters],
    queryFn: () => {
      const params = { ...filters };
      if (params?.pageSize && !params.limit) params.limit = params.pageSize;
      return fetchAgeGroups(params);
    },
    keepPreviousData: true,
    enabled: options.enabled,
  });

  return {
    ...query,
    data: query.data?.data?.ageGroups ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.pageSize ?? filters?.limit ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export default useAgeGroups;
